import React, { useState } from "react";
import "./Calendar.css";

const Calendar = ({ selectedDate, onDateSelect, reportDates }) => {
  const [currentMonth, setCurrentMonth] = useState(new Date());

  const getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    const startingDayOfWeek = firstDay.getDay();

    const days = [];

    // Add empty cells for days before month starts
    for (let i = 0; i < startingDayOfWeek; i++) {
      days.push(null);
    }

    // Add days of the month
    for (let day = 1; day <= daysInMonth; day++) {
      days.push(new Date(year, month, day));
    }

    return days;
  };

  const hasReports = (date) => {
    if (!date) return false;
    return reportDates.some((reportDate) => reportDate.toDateString() === date.toDateString());
  };

  const isSelected = (date) => {
    if (!date || !selectedDate) return false;
    return date.toDateString() === selectedDate.toDateString();
  };

  const monthYear = currentMonth.toLocaleDateString("en-US", {
    month: "long",
    year: "numeric",
  });

  const prevMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1));
  };

  const nextMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1));
  };

  const days = getDaysInMonth(currentMonth);
  const weekDays = ["M", "T", "W", "T", "F", "S", "S"];

  return (
    <div className="calendar">
      <div className="calendar-header">
        <button onClick={prevMonth} className="calendar-nav-button">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d="M12.5 15L7.5 10L12.5 5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <span className="calendar-month-year">{monthYear}</span>
        <button onClick={nextMonth} className="calendar-nav-button">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d="M7.5 5L12.5 10L7.5 15"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>

      <div className="calendar-week-days">
        {weekDays.map((day, index) => (
          <div key={index} className="calendar-week-day">
            {day}
          </div>
        ))}
      </div>

      <div className="calendar-days-grid">
        {days.map((day, index) => (
          <div key={index} className="calendar-day-cell">
            {day && (
              <button
                onClick={() => onDateSelect(day)}
                className={`calendar-day-button ${isSelected(day) ? "selected" : ""} ${
                  hasReports(day) && !isSelected(day) ? "has-reports" : ""
                }`}
              >
                {day.getDate()}
                {hasReports(day) && !isSelected(day) && <div className="calendar-report-indicator"></div>}
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Calendar;
